export enum MenuHoverStyleEnum {
    'HIGHLIGHT_ONLY' = 'HIGHLIGHT_ONLY',
    'BOTTOM_LINE' = 'BOTTOM_LINE',
    'BACKGROUND_HIGHLIGHT' = 'BACKGROUND_HIGHLIGHT',
}

